module.exports = __webpack_public_path__ + "img/00-menu-bar-on_05.f145d847.png";